module.exports = __webpack_public_path__ + "media/images/gallery/stars_on-a8e4000c512bcfb2c22f6964c128a03a.gif";